import { useQuery as useQueryParams, useParams as useRouteParams } from '../../../../contexts/RouterContext';
import type { SnippetsQueryParams } from '../../../../../shared/snippets';
import type { SnippetsRouteParams } from '../../../../hooks/api/snippets/shared';

type IsComparingSnippetsInfo = {
  isComparing: true;
  status: string;
  olderRevisionLocator: string;
};

type NotComparingSnippetsInfo = {
  isComparing: false;
};

export type ComparedSnippetsInfo = IsComparingSnippetsInfo | NotComparingSnippetsInfo;

/**
 * Utility hook to determine if the user is currently comparing snippets.
 * If so, include the status and older revision locator.
 */
const useComparedSnippetsInfo = (): ComparedSnippetsInfo => {
  const routeParams = useRouteParams<SnippetsRouteParams>();
  const [queryParams] = useQueryParams<SnippetsQueryParams>();

  if (!!routeParams.status && !!queryParams.olderRevisionLocator) {
    return {
      isComparing: true,
      status: routeParams.status,
      olderRevisionLocator: queryParams.olderRevisionLocator,
    };
  }

  return {
    isComparing: false,
  };
};

export default useComparedSnippetsInfo;
